import { Logger } from '@nvision/services/logger';

export const logger = new Logger({ isEnabled: true, prefix: 'fetcher' });
